import { render, staticRenderFns } from "./notReady.vue?vue&type=template&id=06651514&"
import script from "./notReady.vue?vue&type=script&lang=js&"
export * from "./notReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports